import type { FailureCashOutFromBackend } from 'app/api/services/stakes/cash-out/types';

import { CashoutErrorCode, StakeCashoutState } from 'app/lib/staking/constants';

import { RecordOfStake, StakeErrorEntity } from '../records';

// ---

type Result = {
  amount?: number;
  error: CashoutErrorCode | null;
  message?: string | null;
} | FailureCashOutFromBackend;

export default function setupEntryError(
  entry: RecordOfStake,
  result?: Result,
): RecordOfStake {
  const amount = result && ('amount' in result && result.amount) || 0;
  const status = result && ('error' in result && result.error) || CashoutErrorCode.INTERNAL_SERVER_ERROR;

  const message = result && 'message' in result && result.message || '';

  const errorEntry = StakeErrorEntity({ message, code: status });

  switch (status) {
    case CashoutErrorCode.AMOUNT_CHANGED:
      const prevAmount = entry.cashoutAmount;

      return entry
        .set('cashoutState', StakeCashoutState.REJECTED)
        .set('cashoutAmount', amount)
        .set('error', errorEntry.set('prevAmount', prevAmount));

    case CashoutErrorCode.BETTING_IS_CLOSED:
    case CashoutErrorCode.CASH_OUT_IN_PROCESS:
    case CashoutErrorCode.NOT_FOUND:
    case CashoutErrorCode.UNAUTHORIZED:
    case CashoutErrorCode.NOT_ACCEPTABLE:
      return entry
        .set('cashoutState', StakeCashoutState.REJECTED)
        .set('error', errorEntry);

    case CashoutErrorCode.INTERNAL_SERVER_ERROR:
    default:
      return entry
        .set('cashoutState', StakeCashoutState.FAILED)
        .set('error', errorEntry);
  }
}
